import { Fragment, useContext, useEffect, useState } from "react";
import {
  Card,
  Loading,
  Select,
  PaginationData,
  TableNumber,
  Button,
  TableHeaderSort,
  Input,
  BaseTable,
  PermissionLink,
  Checkbox,
  TableSorting,
} from "../../../../components";
import { useList } from "../../Transaction/AddNewItem/utils";
import { Delete } from "../../Transaction/AddNewItem/components/ChildItem/components/Item/components";
import { ProductList } from "../../Transaction/AddNewItem/types";
import {
  convertNumber,
  default_pagination_value,
  useApi,
  useMultipleSelect,
  useToggle,
} from "utils";
import { useProductCategory } from "./utils";
import debounce from "lodash/debounce";
import { TbChevronRight, TbTrash } from "react-icons/tb";
import { PicturesSection, Print } from "./components";
import { IoSendSharp } from "react-icons/io5";
import { PrintItemContext } from "./contexts";
import { DataContext } from "../utils/contexts";
import { deleteAlert, useAllId } from "./utils";
import toast from "react-hot-toast";
import { FilterColumn } from "../components";
import { PERMISION } from "security";
import { DateFilter } from "components/widgets/DashboardFilter/components";
import { useLocation } from "utils"
import moment from "moment"

type PaginationState = {
  total: number;
  page: number;
  limit: number;
  pages: number;
  keyword: string;
  group_id?: string;
  buy?: boolean;
  sell?: boolean;
  inv?: boolean;
  build?: boolean;
  sort?: string;
  location_id?: string;
  yearmonth?: string;
};
export function ItemsGroup() {
  // Context
  const { setFill, setActiveColumn } = useContext(DataContext);
  const { data: locationData, isLoading: isLoadingLocation } = useLocation();

  // Hooks
  const multiple = useMultipleSelect();
  const [pagination, setPagination] = useState<PaginationState>({
    ...default_pagination_value,
    yearmonth: moment().format("YYYYMM"),
    location_id: "",
  });

  const { data, isLoading, refetch } = useList(pagination);
  const dataList: ProductList[] = data.items;

  const dataLength = data.pagination_data.size;
  const pageCurrent = pagination.page;
  const limit = pagination.limit;
  const totalData = pagination.total;
  const onDebounce = debounce((e: any) =>
    setPagination((prev) => {
      return {
        ...prev,
        keyword: e.target.value,
        page: 1,
        group_id: "",
        sort: "",
      };
    })
  );

  const header: TableSorting[] = [
    { title: "BSI", sort: false, value: "bsi", isActive: true, align: "center" },
    { title: "BUILD", sort: false, value: "build", isActive: true, align: "center" },
    { title: "ITEM CODE", sort: true, value: "code", isActive: true },
    { title: "ITEM NAME", sort: true, value: "name", isActive: true },
    { title: "CATEGORY", sort: true, value: "category", isActive: true },
    { title: "AVERAGE COST", sort: true, value: "average_cost", align: "right", isActive: true },
    { title: "LAST PRICE", sort: true, value: "last_price", align: "right", isActive: true },
    { title: "SELLING PRICE", sort: true, value: "price_retail", align: "right", isActive: true },
    { title: "SOH", sort: true, value: "soh", align: "right", isActive: true },
    { title: "UNIT", sort: true, value: "unit", align: "right", isActive: true },
  ];

  const [tableActive, setTableActive] = useState<TableSorting[]>(header);

  const sortMapping: Record<string, string> = {
    "ITEM CODE": "code",
    "ITEM NAME": "name",
    CATEGORY: "group_id",
    "AVERAGE COST": "averagecost",
    "LAST PRICE": "lastprice",
    "SELLING PRICE": "sellprice",
    SOH: "soh",
    UNIT: "unitconv",
  };

  const { dataCategory, isLoadingCategory } = useProductCategory();

  const refreshPage = () => {
    setPagination({ ...pagination, page: 1, group_id: "", sort: "" });
    refetch();
  };

  const handleSort = (item: string, sortType: string) => {
    const sortParam = sortMapping[item]
      ? `${sortMapping[item]}:${sortType}`
      : "";
    setPagination({ ...pagination, sort: sortParam });
  };

  useEffect(() => {
    setFill({
      buy: pagination.buy,
      sell: pagination.sell,
      inv: pagination.inv,
      build: pagination.build,
      group_id: pagination.group_id
    })
    setActiveColumn && setActiveColumn(tableActive);
    
  }, [setFill, pagination.build, pagination.buy, pagination.sell, pagination.inv, pagination.group_id, setActiveColumn, tableActive]);


  return (
    <Fragment>
      <section className="my-2">
        <>
          <section className="mt-2 sticky top-[120px] z-[3]">
            <Card>
              <Card.Body>
                <div className="flex justify-end gap-3">
                  <DeleteMultiple
                    item={multiple.item}
                    onSuccess={refreshPage}
                  />

                  <PrintItemContext.Provider
                    value={{
                      items: dataList,
                      selectedItem: multiple.item,
                    }}
                  >
                    <Print />
                  </PrintItemContext.Provider>


                </div>
                <div className="lg:flex lg:justify-between items-center">
                  <div className="lg:flex items-end gap-3">
                    <Input
                      label="SEARCH"
                      className="lg:w-[300px] md:w-full"
                      placeholder="Search data..."
                      onChange={onDebounce}
                    />

                    <div className="mr-5">
                      <FilterColumn dataFilter={tableActive} setTableActive={setTableActive} />
                    </div>

                    <div className="flex items-center gap-3 lg:mb-3 mt-3">
                      <Checkbox
                        defaultChecked={pagination?.buy}
                        onChange={(e) =>
                          setPagination({
                            ...pagination,
                            buy: e.target.checked ?? "",
                            page: 1,
                          })
                        }
                      >
                        BUY
                      </Checkbox>
                      <Checkbox
                        defaultChecked={pagination?.sell}
                        onChange={(e) =>
                          setPagination({
                            ...pagination,
                            sell: e.target.checked ?? "",
                            page: 1,
                          })
                        }
                      >
                        SELL
                      </Checkbox>
                      <Checkbox
                        defaultChecked={pagination?.inv}
                        onChange={(e) =>
                          setPagination({
                            ...pagination,
                            inv: e.target.checked ?? "",
                            page: 1,
                          })
                        }
                      >
                        INVENTORY
                      </Checkbox>
                      <Checkbox
                        defaultChecked={pagination?.build}
                        onChange={(e) =>
                          setPagination({
                            ...pagination,
                            build: e.target.checked ?? "",
                            page: 1,
                          })
                        }
                      >
                        <span className="text-nowrap">BUILD ITEM</span>
                      </Checkbox>
                    </div>
                  </div>

                  <div className="flex gap-2">
                    <DateFilter
                      monthOnly
                      value={{
                        start_date: moment(pagination.yearmonth, "YYYYMM")
                          .startOf("month")
                          .format("YYYY-MM-DD"),
                        end_date: moment(pagination.yearmonth, "YYYYMM")
                          .endOf("month")
                          .format("YYYY-MM-DD"),
                        type: "Month",
                      }}
                      onChangeStartDate={(val) => {
                        setPagination({
                          ...pagination,
                          yearmonth: moment(val).format("YYYYMM"),
                          page: 1,
                        });
                      }}
                    />

                    <Select
                      label="LOCATION"
                      placeholder="All"
                      className="w-[180px]"
                      isLoading={isLoadingLocation}
                      options={[
                        { label: "All", value: "" },
                        ...locationData,
                      ]}
                      value={[
                        { label: "All", value: "" },
                        ...locationData,
                      ].find(item => item.value === pagination.location_id)}
                      onChange={(e) =>
                        setPagination({
                          ...pagination,
                          location_id: e?.value ?? "",
                          page: 1,
                        })
                      }
                    />
                  </div>

                  <div className="lg:flex lg:items-end gap-2">
                    <PermissionLink
                      permission={PERMISION.INVENTORY.REGISTER.REGISTER_GROUP.CREATE}
                      to={"/inventory/transaction/add-new-item"}
                    >
                      <Button
                        color="primary"
                        className="w-[120px] mb-2"
                        permission={PERMISION.INVENTORY.REGISTER.REGISTER_GROUP.CREATE}
                      >
                        CREATE <TbChevronRight /></Button>
                    </PermissionLink>

                    <Select
                      label="PRODUCT CATEGORY"
                      placeholder="Select product category here..."
                      className="lg:w-[200px] w-full me-2 mb-2"
                      width={true}
                      defaultValue={{ value: "0", label: "All" }}
                      isLoading={isLoadingCategory}
                      options={[{ label: "All", value: "" }].concat(
                        dataCategory
                      )}
                      value={dataCategory.find(
                        (item) => item.value === pagination?.group_id
                      )}
                      onChange={(e) =>
                        setPagination({
                          ...pagination,
                          group_id: e?.value ?? "",
                          page: 1,
                        })
                      }
                    />
                    <div className="w-full">
                      <Button
                        className="uppercase sm:rounded-lg border-white hover:border-primary hover:bg-primary hover:text-black mb-2 w-full"
                        onClick={() => refreshPage()}
                      >
                        Lastest Item
                      </Button>
                    </div>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </section>
          <section className="mt-2">
            <Card>
              <Card.Body>
                <div className="overflow-x-auto max-h-[calc(100vh-600px)]">
                  <BaseTable className="border-collapse">
                    <thead className="sticky top-[200px] z-[1] !bg-black !text-white">
                      <tr>
                        <th>NO</th>
                        <th>PICTURES</th>

                        <th>
                          <AllCheckbox
                            selectedItem={multiple.item}
                            onChange={multiple.handleData}
                          />
                        </th>

                        {/* <th>BSI</th> */}

                        <TableHeaderSort
                          title={tableActive}
                          onSort={(item, sortType) =>
                            handleSort(item, sortType)
                          }
                        />

                        <th>ACTION</th>
                      </tr>
                    </thead>

                    <tbody>
                      {isLoading ? (
                        <tr>
                          <td colSpan={13} className="text-center">
                            <Loading loading />
                          </td>
                        </tr>
                      ) : (
                        <>
                          {dataList.length === 0 ? (
                            <tr>
                              <td colSpan={13} className="text-center">
                                <Loading errorText="No data available" />
                              </td>
                            </tr>
                          ) : (
                            <Fragment>
                              {dataList.map((item: any, key: any) => (
                                <tr>
                                  <td>
                                    {TableNumber({
                                      dataLength: dataLength,
                                      pageCurrent: pageCurrent,
                                      index: key,
                                      limit: limit,
                                      totalData: totalData,
                                    })}
                                  </td>
                                  <td className="!w-[80px]">
                                    <div className="flex justify-center">
                                      {Boolean(item?.pictures.length) && (
                                        <PicturesSection
                                          dataPicture={item?.pictures}
                                          items={1}
                                          className="size-[50px] my-[-10px]"
                                        />
                                      )}
                                    </div>
                                  </td>
                                  <td className="text-center">
                                    <Checkbox
                                      value={Boolean(
                                        multiple.item.find(
                                          (i) =>
                                            i === item.product_id?.toString()
                                        )
                                      )}
                                      onClick={() =>
                                        multiple.handleData(
                                          item.product_id?.toString()
                                        )
                                      }
                                    />
                                  </td>


                                  {/* Kolom filter */}
                                  {tableActive
                                    .filter((col) => col.isActive !== false)
                                    .map((col, idx) => (
                                      <Fragment key={idx}>
                                        {renderCell(col.value!, item)}
                                      </Fragment>
                                    ))}



                                  <td>
                                    <section className="join flex items-center gap-2">
                                      <PermissionLink
                                        permission={PERMISION.INVENTORY.REGISTER.REGISTER_GROUP.UPDATE}
                                        to={`/inventory/transaction/add-new-item/update/${item.product_id}`}
                                      >
                                        <IoSendSharp />
                                      </PermissionLink>
                                      <Delete id={item} refetch={refetch} />
                                    </section>
                                  </td>
                                </tr>
                              ))}
                            </Fragment>
                          )}
                        </>
                      )}
                    </tbody>
                  </BaseTable>
                  <div className="mt-5">
                    <PaginationData
                      data={data}
                      pagination={pagination}
                      setPagination={setPagination}
                    />
                  </div>
                </div>
              </Card.Body>
            </Card>
          </section>
        </>
      </section>
    </Fragment>
  );
}

function AllCheckbox(params: {
  selectedItem: string[];
  onChange: (value: string[]) => void;
}): JSX.Element {
  // Hooks
  const { data, isLoading } = useAllId();

  // Vars
  const isChecked: boolean = params.selectedItem.length === data.length;

  if (isLoading) {
    return <Loading loading />;
  } else if (data.length) {
    return (
      <Checkbox
        value={isChecked}
        onClick={() => params.onChange(isChecked ? [] : data)}
      />
    );
  }

  return <></>;
}

function DeleteMultiple(params: {
  item: string[];
  onSuccess: () => void;
}): JSX.Element {
  // Vars
  const item = params.item;

  // Hooks
  const api = useApi();
  const { isActive, setActive } = useToggle(false);

  // Functions
  const deleteData = (): void => {
    setActive(true);

    toast
      .promise(api.delete("/product/delete-multiple", { data: item }), {
        loading: "Loading...",
        success: (res) => res.data.message,
        error: (err) => err.response.data.message,
      })
      .then(() => {
        params.onSuccess();
      })
      .catch(() => { })
      .finally(() => {
        setActive(false);
      });
  };

  if (item.length) {
    return (
      <Button
        color="primary"
        loading={isActive ? "true" : undefined}
        onClick={() => {
          deleteAlert()
            .then(() => {
              deleteData();
            })
            .catch(() => { });
        }}
      >
        {!isActive && <TbTrash size={20} />}
      </Button>
    );
  }

  return <></>;
}


function renderCell(title: string, item: any) {
  const currency = (val: string | number) =>
    convertNumber(parseFloat(val?.toString()))?.intoCurrency ?? "-";

  switch (title) {
    case "bsi":
      return <td className="text-center">{`${item.buy ? "B" : ""}${item.sell ? "S" : ""}${item.inventory ? "I" : ""}`}</td> ;
    case "build":
      return (
        <td className="text-center">
          <input
          type="checkbox"
          className="checkbox checkbox-primary"
          checked={item.build_item}
          disabled
        /></td>
      );
    case "code":
      return <td>{item.product_barcode}</td>;
    case "name":
      return <td className="truncate w-40">{item.product_name}</td>;
    case "category":
      return <td>{item.mr_product_category_name}</td>;
    case "average_cost":
      return <td className="text-right">{item.avg_price ? currency(item.avg_price) : "0"}</td>;
    case "last_price":
      return <td className="text-right">{!item.build_item && item.last_price ? currency(item.last_price) : "-"}</td>;
    case "price_retail":
      return <td className="text-right">{item.price_retail ? currency(Number(item.price_retail)) : "-"}</td>;
    case "soh":
      return <td className="text-right">{item.soh ? currency(item.soh) : "-"}</td>;
    case "unit":
      return <td>{item.unit_convention}</td>;
    default:
      return "-";
  }
}



